
import { useState } from 'react'
import './styles/buzon.css'
import PanelBuzon from '../components/buzon-components/PanelBuzon'
import PanelCMDB from '../components/cis-components/PanelCMDB'
const Buzon=({server,dataGlobals,languaje,mode ,handleShowPopup })=>{
    const [listSelected,setListSelected]=useState(1)
    const hadleChangeList=(e)=>{
        setListSelected(e)
    }
    return (
        <div className={"main-cis"+mode}>
             
                    <PanelBuzon handleShowPopup={handleShowPopup}languaje={languaje} mode={mode} server={server}/>
                
            
        </div>
    )
}

export default Buzon